import axios from "axios";
import api from "../conf/ruta-base";
const URL = "/storage/upload";

export const uploadFile = async (file, customFileName = 'file') => {
    let form = new FormData();
    const customFile = new File([file], customFileName, { type: file.type });
    form.append('file', customFile);
    const response = await axios.post(`${api.api}${URL}`, form, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        }
    });
    return response.data.url;
}